import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaDiarias = '/service/contabilidade/dotacaoempenho/'

class ReceitaArrecadadaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            nome: filtro.nome,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : '',
            dataEmpenhoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).format('YYYY-MM-DD') : '',
            dataEmpenhoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).format('YYYY-MM-DD') : '',
            cargo: filtro.cargo ? filtro.cargo.map(e => e.value) : '',
            situacaoPagamento: filtro.situacaoPagamento ? filtro.situacaoPagamento.value : '',
        }

        return this.conex.post(urlConsultaDiarias + 'consultaDiarias/', JSON.stringify(data))
    }
}

export default ReceitaArrecadadaService
